// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"521":"b766ef233d6cc968","583":"08ae584e641b229f"}[chunkId] + ".js";
};